import { render } from "./TableWithFixedColumnsAndHeader.vue?vue&type=template&id=8229da12"
import script from "./TableWithFixedColumnsAndHeader.vue?vue&type=script&lang=js"
export * from "./TableWithFixedColumnsAndHeader.vue?vue&type=script&lang=js"
script.render = render

export default script